import React, { useState, useEffect, useRef } from "react";
import { RotationContainer } from "./styles.js";

const startSpinTime = 800;
const stopSpinTime = 3400;

export const Wheel = ({ mustStartSpinning, prizeNumber, wheelImage, onClickingStop, prizeTotal, country, onStopSpinning = () => null,
}) => {
  const [contSpinTime, setContSpinningTime] = useState(1);
  const [startRotationDegrees, setStartRotationDegrees] = useState(0);
  const [finalRotationDegrees, setFinalRotationDegrees] = useState(0);
  const [hasStartedSpinning, setHasStartedSpinning] = useState(false);
  const [hasStoppedSpinning, setHasStoppedSpinning] = useState(false);
  const [isCurrentlySpinning, setIsCurrentlySpinning] = useState(false);
  const mustStopSpinning = useRef(false);
  const randoNumber = Math.random() * 1.6;
  const randomNoNegative = Math.round(randoNumber) ? 1 : -1;
  
  const resetWheelPos = () => {
    setStartRotationDegrees(0);
    setFinalRotationDegrees(0);
    setHasStartedSpinning(false);
    setHasStoppedSpinning(true);
    setIsCurrentlySpinning(false);
    console.log('RESET WHEEL')
  };

  let prizeToUse;
  // PRIZEID : WHEEL POSITION 
  if (country === 'fr') {
    const convertPrize = {
      1:1,
      2:2,
      3:3,
      4:4,
      5:5,
      6:6,
      7:7,
      8:8,
    };
    prizeToUse = convertPrize[prizeNumber];
  }
  const getRotationDegrees = (prizeToUse, numberOfPrizes) => {
    const degreesPerPrize = 360 / numberOfPrizes;
    const prizeRotation = degreesPerPrize * (numberOfPrizes - prizeToUse);
    return numberOfPrizes - prizeToUse > numberOfPrizes / 2 ? -360 + prizeRotation : prizeRotation;
  };

  const startSpinning = () => {
    resetWheelPos();
    setHasStartedSpinning(true);
    setHasStoppedSpinning(false);
    mustStopSpinning.current = true;
  };

  useEffect(() => {
    if (mustStartSpinning && !isCurrentlySpinning) {
      setIsCurrentlySpinning(true);
      startSpinning();
    }
  }, [mustStartSpinning]);

  useEffect(() => {
    const finalRotationDegreesCalculated = getRotationDegrees(prizeToUse, prizeTotal);
    const finalDegree = (finalRotationDegreesCalculated + ((randoNumber * (randomNoNegative * 2)) * 2))
    // const finalDegree = (finalRotationDegreesCalculated + ((randoNumber * (randomNoNegative * 1)) * 1))
    setFinalRotationDegrees(finalDegree);
    if (prizeToUse) {
      setTimeout(() => {
        if (mustStopSpinning.current) {
          mustStopSpinning.current = false;
          setStartRotationDegrees(finalDegree);
          setHasStartedSpinning(false);
          setHasStoppedSpinning(true);
          onStopSpinning();
        }
      }, startSpinTime + stopSpinTime - 15);
    }
  }, [prizeToUse])


  // Return Animation Classnames to wheel
  const checkPrizeNo = () => {
    if (hasStartedSpinning && !prizeToUse) {return "started-spinning";
    } else if (hasStartedSpinning && prizeToUse && onClickingStop) { return "cont-spinning";} 
    else { return ""; }
  }

  return (
    <>
      <RotationContainer
        className={checkPrizeNo()}
        startSpinningTime={startSpinTime}
        continueSpinningTime={contSpinTime}
        stopSpinningTime={stopSpinTime}
        startRotationDegrees={startRotationDegrees}
        finalRotationDegrees={finalRotationDegrees}
      >
        <img
          src={wheelImage}
          alt="wheel"
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            margin: "0 auto",
            transform: `rotate(${ (((360/prizeTotal) / 2) - (360/prizeTotal) / 2 )+90}deg)`
          }}
        />
      </RotationContainer>
    </>
  );
};
